import { render, staticRenderFns } from "./viewFactory.vue?vue&type=template&id=0ccf0fc6&scoped=true&"
import script from "./viewFactory.vue?vue&type=script&lang=js&"
export * from "./viewFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf0fc6",
  null
  
)

export default component.exports